import { jsx as emotion } from "@emotion/react";
import css, { SystemStyleObject } from "@styled-system/css";
import lodashOmit from "lodash/omit";
import type { JSX as ReactJSX, JSXElementConstructor } from "react";

const parseProps = (props: any) => {
  if (!props) {
    return null;
  }
  if (!props.sx) {
    return props;
  }

  return lodashOmit(
    {
      ...props,
      css: css(props.sx as SystemStyleObject),
    },
    "sx",
  );
};

/**
 * @deprecated Please use `styled()` from \@outschool/backpack for adding the sx prop.
 */
function jsxPragma(
  type: any,
  props: any,
  ...children: any[]
): React.ReactElement {
  return emotion(type, parseProps(props), ...children);
}

/**
 * JSX types for files using `/** @jsx jsxPragma *\/`. TypeScript looks up the
 * JSX namespace on the factory, so every element rendered through the pragma
 * accepts `sx`, which parseProps converts to emotion's `css`.
 */
// eslint-disable-next-line @typescript-eslint/no-namespace
namespace jsxPragma {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  export namespace JSX {
    export type ElementType = string | JSXElementConstructor<any>;
    export type Element = ReactJSX.Element;
    export type ElementClass = ReactJSX.ElementClass;
    export type ElementAttributesProperty = ReactJSX.ElementAttributesProperty;
    export type ElementChildrenAttribute = ReactJSX.ElementChildrenAttribute;
    export type LibraryManagedAttributes<C, P> =
      ReactJSX.LibraryManagedAttributes<C, P>;
    export type IntrinsicAttributes = ReactJSX.IntrinsicAttributes & {
      sx?: SystemStyleObject;
    };
    export type IntrinsicClassAttributes<T> =
      ReactJSX.IntrinsicClassAttributes<T>;
    export type IntrinsicElements = {
      [K in keyof ReactJSX.IntrinsicElements]: ReactJSX.IntrinsicElements[K] & {
        sx?: SystemStyleObject;
      };
    };
  }
}

export default jsxPragma;
